module.exports = __webpack_public_path__ + "img/tl.e2ec2394.svg";